(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["namai-cinematic"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('namai-cinematic')) {
    customElements.define('namai-cinematic', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        if (!this.video || !this.button) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.video.muted = true;
        this.video.playsInline = true;
        this.button.hidden = false;
        this.update = () => {
          this.button.setAttribute('aria-label', this.video.paused ? this.button.dataset.play : this.button.dataset.pause);
          this.button.firstElementChild.textContent = this.video.paused ? '▶' : 'Ⅱ';
        };
        this.video.addEventListener('play', this.update, options);
        this.video.addEventListener('pause', this.update, options);
        this.button.addEventListener('click', () => {
          this.wantsPlayback = this.video.paused;
          if (this.wantsPlayback) this.video.play().catch(this.update);
          else this.video.pause();
        }, options);
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.wantsPlayback = !this.motion.matches;
        this.motion.addEventListener('change', () => {
          this.wantsPlayback = !this.motion.matches;
          if (this.wantsPlayback) this.video.play().catch(this.update);
          else this.video.pause();
        }, options);
        this.observer = new IntersectionObserver(entries => {
          if (entries[0].isIntersecting && this.wantsPlayback && !document.hidden) this.video.play().catch(this.update);
          else this.video.pause();
        }, { threshold: .1 });
        this.observer.observe(this);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.video.pause();
          else if (this.wantsPlayback && this.getBoundingClientRect().bottom > 0) this.video.play().catch(this.update);
        }, options);
        this.update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["namai-design-studio"] && !Shopify.designMode) return;
  try {
    

(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const canvas = root.querySelector('canvas'), ctx = canvas.getContext('2d');
    const fileInput = root.querySelector('[data-art]'), status = root.querySelector('[data-status]');
    const fit = root.querySelector('[data-fit]'), color = root.querySelector('[data-color]'), caption = root.querySelector('[data-caption]');
    const remove = root.querySelector('[data-remove]'), download = root.querySelector('[data-download]');
    let artwork = null, sequence = 0;
    let step = 0;
    const panels = [...root.querySelectorAll('[data-panel]')], stepButtons = [...root.querySelectorAll('[data-step]')];
    const patternInputs = [...root.querySelectorAll('[data-pattern]')], placement = root.querySelector('[data-placement]');
    function summary() {
      const pattern = root.querySelector('[data-pattern]:checked');
      const items = [[root.dataset.summaryBase, color.value], [root.dataset.summaryPattern, pattern.parentElement.innerText.trim()], [root.dataset.summaryText, caption.value.trim() || root.dataset.none], [root.dataset.summaryArt, artwork ? root.dataset.artAdded : root.dataset.none]];
      const dl=root.querySelector('[data-summary]');dl.replaceChildren();
      for(const [label,value] of items){const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=label;dd.textContent=value;dl.append(dt,dd);}
      const spec=root.querySelector('[data-build-spec]');if(spec)spec.value=items.map(([k,v])=>k+': '+v).join(' | ')+' | Layout: '+fit.value+' | Text placement: '+placement.value;
    }
    function showStep(i, focus) {
      step=Math.max(0,Math.min(3,i));
      panels.forEach((p,index)=>{p.hidden=index!==step;});
      stepButtons.forEach((b,index)=>{if(index===step)b.setAttribute('aria-current','step');else b.removeAttribute('aria-current');});
      root.querySelector('[data-back]').hidden=step===0;root.querySelector('[data-next]').hidden=step===3;
      summary();if(focus)stepButtons[step].focus();
    }
    stepButtons.forEach(b=>b.addEventListener('click',()=>showStep(Number(b.dataset.step),false)));
    root.querySelector('[data-back]').addEventListener('click',()=>showStep(step-1,true));
    root.querySelector('[data-next]').addEventListener('click',()=>showStep(step+1,true));
    if (!ctx) { status.textContent = root.dataset.unavailable; download.disabled = true; return; }
    const mat = { x: 250, y: 100, w: 580, h: 1360 };
    function shape() { ctx.beginPath(); ctx.roundRect(mat.x,mat.y,mat.w,mat.h,22); }
    function draw() {
      ctx.clearRect(0,0,canvas.width,canvas.height);
      ctx.save();
      ctx.shadowColor = 'rgba(20,35,25,.22)'; ctx.shadowBlur=38; ctx.shadowOffsetY=24;
      ctx.fillStyle=color.value; shape(); ctx.fill(); ctx.restore();
      ctx.save(); shape(); ctx.clip();
      ctx.fillStyle=color.value; ctx.fillRect(mat.x,mat.y,mat.w,mat.h);
      const pattern=root.querySelector('[data-pattern]:checked').value;
      ctx.save();ctx.strokeStyle='rgba(255,255,255,.32)';ctx.fillStyle='rgba(255,255,255,.26)';ctx.lineWidth=3;
      if(pattern==='stripe'){for(let x=mat.x-1400;x<mat.x+mat.w;x+=75){ctx.beginPath();ctx.moveTo(x,mat.y);ctx.lineTo(x+1400,mat.y+mat.h);ctx.stroke();}}
      if(pattern==='dots'){for(let x=mat.x+25;x<mat.x+mat.w;x+=65)for(let y=mat.y+25;y<mat.y+mat.h;y+=65){ctx.beginPath();ctx.arc(x,y,5,0,Math.PI*2);ctx.fill();}}
      if(pattern==='contour'){for(let r=60;r<1600;r+=50){ctx.beginPath();ctx.ellipse(mat.x+mat.w*.25,mat.y+mat.h*.35,r*.55,r,Math.PI/6,0,Math.PI*2);ctx.stroke();}}
      ctx.restore();
      if (artwork) {
        const factor = fit.value === 'cover' ? Math.max(mat.w/artwork.width,mat.h/artwork.height) : Math.min(mat.w/artwork.width,mat.h/artwork.height);
        const w=artwork.width*factor,h=artwork.height*factor;
        ctx.drawImage(artwork,mat.x+(mat.w-w)/2,mat.y+(mat.h-h)/2,w,h);
      } else {
        ctx.strokeStyle='rgba(255,255,255,.10)'; ctx.lineWidth=1;
        for(let y=mat.y;y<mat.y+mat.h;y+=10){ctx.beginPath();ctx.moveTo(mat.x,y);ctx.lineTo(mat.x+mat.w,y);ctx.stroke();}
        ctx.fillStyle='#f5f2eb';ctx.textAlign='center';ctx.font='18px sans-serif';if(pattern==='solid')ctx.fillText(root.dataset.empty,mat.x+mat.w/2,mat.y+mat.h/2,mat.w-60);
      }
      if(caption.value.trim()) {
        ctx.fillStyle='rgba(20,35,25,.6)';const textY=placement.value==='top'?mat.y+75:placement.value==='center'?mat.y+mat.h/2:mat.y+mat.h-75;ctx.fillRect(mat.x,textY-75,mat.w,150);
        ctx.fillStyle='#fff';ctx.textAlign='center';ctx.font='28px sans-serif';ctx.fillText(caption.value.trim(),mat.x+mat.w/2,textY+10,mat.w-50);
      }
      ctx.restore();summary();
    }
    async function load(file) {
      const current = ++sequence;
      if(!file) return;
      if(!['image/png','image/jpeg','image/webp'].includes(file.type)||file.size>10*1024*1024){status.textContent=root.dataset.fileError;fileInput.value='';return;}
      const url=URL.createObjectURL(file), img=new Image();
      try {
        img.src=url; await img.decode();
        if(current !== sequence) return;
        if(img.width*img.height>50000000) throw new Error('dimensions');
        artwork=img;remove.hidden=false;status.textContent=root.dataset.fileReady;draw();
      } catch {if(current===sequence) status.textContent=root.dataset.fileError;}
      finally {URL.revokeObjectURL(url);}
    }
    fileInput.addEventListener('change',()=>load(fileInput.files[0]));
    const drop=root.querySelector('.ns-drop');
    for(const type of ['dragenter','dragover'])drop.addEventListener(type,e=>{e.preventDefault();drop.classList.add('is-dragging');});
    for(const type of ['dragleave','drop'])drop.addEventListener(type,e=>{e.preventDefault();drop.classList.remove('is-dragging');});
    drop.addEventListener('drop',e=>load(e.dataTransfer.files[0]));
    [fit,color,caption,placement,...patternInputs].forEach(el=>el.addEventListener('input',draw));
    function clear(){++sequence;artwork=null;fileInput.value='';remove.hidden=true;status.textContent='';draw();}
    remove.addEventListener('click',clear);
    root.querySelector('[data-reset]').addEventListener('click',()=>{fit.value='cover';color.value='#34473e';caption.value='';placement.value='bottom';patternInputs[0].checked=true;clear();showStep(0,true);});
    download.addEventListener('click',()=>{
      canvas.toBlob(blob=>{
        if(!blob){status.textContent=root.dataset.unavailable;return;}
        const url=URL.createObjectURL(blob),a=document.createElement('a');a.href=url;a.download='NAMAI-Mat-Concept.png';a.click();setTimeout(()=>URL.revokeObjectURL(url),10000);status.textContent=root.dataset.saved;
      },'image/png');
    });
    showStep(0,false);draw();
  }
  document.querySelectorAll('[data-namai-studio]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-namai-studio]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();
})();
